'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'trophy';
var width = 512;
var height = 512;
var aliases = [127942];
var unicode = 'f091';
var svgPathData = 'M217 309.7c-27.6-30.3-65.5-101-71.8-261.7l222.2 0c-6.4 160.7-44.3 231.4-71.8 261.7-13.7 15.1-25.9 21.4-33.1 24.1-2.6 1-4.7 1.5-6.1 1.9-1.4-.3-3.5-.9-6.1-1.9-7.2-2.7-19.4-9-33.1-24.1zM368.3 0l-224 0c-26.5 0-48.1 21.8-47.1 48.2 .2 5.3 .4 10.6 .7 15.8L48.3 64c-26.1 0-49.1 21.5-47.2 49.7 4.8 70.5 29.4 120.2 63 154.4 32.4 32.9 71.5 49.9 104.8 58.6 22.8 31 46.4 45.2 63.3 51.8l0 85.6-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l208 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-85.6c17.5-6.8 42.3-21.9 65.9-55.3 34-10 72.4-28.1 103.8-60.5 32.8-33.9 56.6-82 61.5-148.9 2-28.3-21.1-49.7-47.1-49.7l-49.6 0c.3-5.2 .5-10.4 .7-15.8 1-26.5-20.6-48.2-47.1-48.2zM411 112l52.3 0c-4.4 55.5-23.8 92.3-47.9 117.2-10.8 11.1-22.8 20.2-35.4 27.6 13.6-36.7 24.8-83.9 31-144.8zM134.3 261.6c-12.6-7.1-24.9-16-35.9-27.2-24.6-25-44.9-63-49.2-122.4l52.4 0c6.5 63.6 18.3 112.3 32.8 149.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTrophy = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;